import {capitalizeFirst} from '../utilities'

/**
 * Formats aggregation type for display by replacing underscores with spaces and capitalizing words
 * @param {string} type - The aggregation type (e.g., 'field_user', 'reviewer', 'installer')
 * @returns {string} - Formatted string (e.g., 'Field User', 'Reviewer', 'Installer')
 */
function formatAggregationType(type) {
  if (!type) return 'Aggregation Type';
  
  // Split by underscore and capitalize each word
  return type.split('_')
    .map(word => capitalizeFirst(word))
    .join(' ');
}

export function generateColumns({aggregationType, betterOrWorse, columnTitles = {}, columnWidths = {}, allUsers = {}}) {
  const betterOrWorseText = betterOrWorse === `better` ? `Better` : `Worse`
  const secondTitle = columnTitles.second || (betterOrWorse === 'better' ? 'No. of Better' : 'No. of Worse')
  const thirdTitle = columnTitles.third || `List of Statistically ${betterOrWorseText} Measures`
  return [
    {
      title: columnTitles.first || formatAggregationType(aggregationType),
      dataIndex: aggregationType,
      width: 60,
      render: (value) => (allUsers && allUsers[value] && allUsers[value].name ? allUsers[value].name : value)
    },
    {
      title: secondTitle,
      dataIndex: `numMeasures`,
      align: `center`,
      width: columnWidths.count || 60,
    },
    {
      title: thirdTitle,
      dataIndex: `listOfMeasures`,
      align: `center`,
      width: columnWidths.third || 400,
    },
  ]
}
